import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';

import SubAbasProdutosDaf from './produtosDadosGerais/subabas';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import StyledLink from '../../../../components/Link';
import SubAbas from '../../../../components/SubAbas';
import Tabela from '../../../../components/Tabela';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { ProaqItemInterno } from '../../../../modules/types/Proaq';
import { useComponentesPaf } from '../../../../services/enum/useComponentesPaf';
import { useProaqFase } from '../../../../services/enum/useProaqFase';
import { useProaqModAquisicao } from '../../../../services/enum/useProaqModAquisicao';
import { useProaqStatus } from '../../../../services/enum/useProaqStatus';
import { useTipoCota } from '../../../../services/enum/useTipoCota';
import { getAllFluxoProaq } from '../../../../services/fluxo/fluxoProaqService';
import { getProaqPorProdutoId } from '../../../../services/processosAquisitivos/proaqService';
import {
  headersProaqs,
  valoresExibidosProaq,
} from '../../ProcessosAquisitivos/auxiliarProaq';
import { offCanvasProaqFunction } from '../../ProcessosAquisitivos/offCanvasProaq';

export default function ProdutosVinculos() {
  //Enums
  const ProaqStatus = useProaqStatus();
  const ProaqFase = useProaqFase();
  const componenteAF = useComponentesPaf();
  const ProaqModAquisicao = useProaqModAquisicao();
  const TipoCota = useTipoCota();
  const theme = useTheme();

  const params = useParams();
  const fichaID = String(params.id);

  //Dados do componente
  let subAbas = [];

  //Proaqs
  const [dataProaq, setDataProaq] = useState<any[]>([]);
  const [fluxoProaqData, setFluxoProaqData] = useState<any[]>([]);

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const proaqs = await getProaqPorProdutoId(id);
      setDataProaq(proaqs);

      const fluxoData = await getAllFluxoProaq();
      setFluxoProaqData(fluxoData);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);

    //Subabas
    subAbas = SubAbasProdutosDaf(fichaID);
  } else {
    subAbas = [
      {
        label: 'Vínculos',
        rota: `#`,
      },
    ];
  }

  //Proaqs
  const tableProaqs = dataProaq.map((item) => {
    // Definindo cores de fundo e texto com base no status do ticket
    let backgroundColor = '';
    let nameItem = 'Não informado';

    const tipoItem = item.denominacaoGenerica ? 'D' : 'K';

    if (tipoItem === 'D') {
      backgroundColor = theme.colors.azul;
      nameItem = item.denominacaoGenerica.denominacaoGenerica;
    } else {
      backgroundColor = theme.colors.laranja;
      nameItem = item.KitProdutoDAF.nomeKit;
    }

    // Definindo cores de fundo e texto com base no status do ticket
    let statusBackgroundColor = '';

    const statusLabel = ProaqStatus[item.status].label;

    if (statusLabel === 'Em Processo') {
      statusBackgroundColor = theme.colors.verde;
    } else if (statusLabel === 'Finalizado') {
      statusBackgroundColor = theme.colors.cinzaEscuro;
    } else if (statusLabel === 'Suspenso') {
      statusBackgroundColor = theme.colors.laranja;
    } else if (statusLabel === 'Cancelado') {
      statusBackgroundColor = theme.colors.vermelho;
    }

    let itensLength = '-';
    if (item.itensArray && item.itensArray.length > 0) {
      itensLength = item.itensArray.length;
    }

    let valorTotal = '-';
    if (item.itensArray && item.itensArray.length > 0) {
      valorTotal = item.itensArray
        .reduce(
          (somador: number, itemAtual: ProaqItemInterno) =>
            somador + parseFloat(itemAtual.valorTotalEstimado || '0'),
          0,
        )
        .toFixed(2);
    }

    let fluxoProaqFaseArray = [];

    const fluxoProaq = fluxoProaqData.find(
      (fluxoProaq) => fluxoProaq.id === item.__fluxoProaq__.id,
    );
    if (fluxoProaq) {
      fluxoProaqFaseArray = fluxoProaq.fluxoProaqFases;
    }
    let faseAtual = 0;
    if (item.faseArray.length > 0) {
      faseAtual = item.faseArray[item.faseArray.length - 1].fase;
    }

    return {
      id: item.id,
      status: (
        <div
          style={{
            textAlign: 'left',
            justifySelf: 'flex-start',
            marginLeft: '-10px',
          }}
        >
          <span
            style={{
              backgroundColor: statusBackgroundColor,
              borderRadius: '10px',
              padding: '10px',
              color: 'white',
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {statusLabel}
          </span>
        </div>
      ),
      fase:
        item.faseArray && item.faseArray.length > 0 ? (
          <>
            <div style={{ lineHeight: 1.8 }}>
              <span
                style={{
                  backgroundColor: theme.colors.roxo,
                  padding: '5px',
                  color: 'white',
                  borderRadius: '5px',
                }}
              >
                <b>{faseAtual}</b>
                <span style={{ fontSize: '0.7rem' }}>
                  {' '}
                  de {fluxoProaqFaseArray.length}
                </span>
              </span>
              {fluxoProaqFaseArray.length > 0
                ? ` ${fluxoProaqFaseArray[faseAtual - 1].nomeFase}`
                : ''}
            </div>
          </>
        ) : (
          'Não iniciado'
        ),
      componenteAF: item.componenteAF
        ? componenteAF[item.componenteAF].label
        : '-',
      modalidadeAquisicao:
        item.__tipoModalidade__?.nomeTipoModalidade ?? 'Não informado',
      denominacaoOuKit: (
        <div
          style={{
            textAlign: 'left',
            justifySelf: 'flex-start',
          }}
        >
          <span
            style={{
              backgroundColor: backgroundColor,
              borderRadius: '7px',
              padding: '4px',
              verticalAlign: 'center',
              textAlign: 'center',
              marginRight: '5px',
              color: 'white',
              display: 'inline-block',
              minWidth: '30px',
              fontSize: '0.8rem',
              fontWeight: 'bold',
            }}
          >
            {tipoItem}
          </span>
          {nameItem}
        </div>
      ),

      itens: (
        <div
          style={{
            textAlign: 'right',
            justifySelf: 'flex-end',
          }}
        >
          <span style={{ justifySelf: 'flex-end' }}>{itensLength}</span>
        </div>
      ),
      valorTotalEstimado: (
        <div
          style={{
            textAlign: 'right',
            justifySelf: 'flex-end',
          }}
        >
          <span style={{ justifySelf: 'flex-end' }}>{valorTotal}</span>
        </div>
      ),
    };
  });

  const offCanvasProaq = offCanvasProaqFunction(
    dataProaq,
    ProaqStatus,
    ProaqFase,
    componenteAF,
    ProaqModAquisicao,
    TipoCota,
    fluxoProaqData,
    theme,
  );

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/produtosdaf/produtos"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <span className="material-icons">arrow_back</span>
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <BoxConteudo boxTitulo="Processos Aquisitivos">
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="100%">
                <Tabela
                  headers={headersProaqs}
                  dataTable={tableProaqs}
                  displayValues={valoresExibidosProaq}
                  dataOffCanvas={offCanvasProaq}
                  showPagination={false}
                  rowClickable={false}
                  pathOffcanvas="daf/proaq/processos"
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>
    </>
  );
}
